<template>
  <!-- Armada -->
  <div :class="`alert alert-custom alert-light-${type} fade show py-2 px-4`">
    <div class="alert-icon pr-3">
      <i style="font-size: 1.5rem" :class="icon || alertIcon"></i>
    </div>
    <div class="alert-text">
      <span class="d-block font-size-sm">
        <slot></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NurseryFeAlert",

  props: {
    type: {
      type: String,
      default: "info",
    },
    icon: {
      type: String,
      default: "",
    },
  },

  computed: {
    alertIcon() {
      switch (this.type) {
        case "info":
          return "ri-information-line";
        case "success":
          return "ri-checkbox-circle-line";
        case "warning":
          return "ri-alert-line";
        case "danger":
          return "ri-close-circle-line";
        default:
          return "ri-information-line";
      }
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/base/component/alert.vue